import { render } from "./AddCourseDetails.vue?vue&type=template&id=7470f5a0&scoped=true"
import script from "./AddCourseDetails.vue?vue&type=script&lang=js"
export * from "./AddCourseDetails.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./AddCourseDetails.vue?vue&type=style&index=1&id=7470f5a0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7470f5a0"]])

export default __exports__